export class OneboxProvider {
  collection = '';
  externalProvider = '';
}
